const STORAGE_KEY = 'novalab_news_items'

export const defaultNews = [
  {
    id: 'news-20260410',
    date: '2026-04-10',
    bg: 'linear-gradient(135deg,#1a0533 0%,#2d1b69 50%,#0a1628 100%)',
    icon: 'el-icon-cpu',
    featured: true,
    locales: {
      zh: {
        title: 'NovaMind-M1',
        excerpt: '新一代医疗大模型结合检验质控知识库、报告审核规则与多模态推理能力，为智慧医院检验平台提供更强的智能分析底座。',
        readTime: '5 分钟阅读',
        category: 'AI 前沿'
      },
      en: {
        title: 'NovaMind-M1',
        excerpt: 'The next-generation medical AI model combines laboratory QC knowledge, report audit rules, and multimodal reasoning to strengthen the intelligence layer for smart hospital laboratory platforms.',
        readTime: '5 min read',
        category: 'AI Insights'
      }
    }
  },
  {
    id: 'news-20260328',
    date: '2026-03-28',
    bg: 'linear-gradient(135deg,#0a1628,#0d2952)',
    icon: 'el-icon-s-cooperation',
    featured: false,
    locales: {
      zh: {
        title: '诺瓦智检与多家医院启动 PBRTQC 实时质控联合验证',
        excerpt: '围绕患者数据实时质控场景，联合临床检验团队开展多中心验证，推动质量管理工具落地应用。',
        readTime: '3 分钟',
        category: '合作动态'
      },
      en: {
        title: 'NovaLab AI Launches Multi-Hospital PBRTQC Validation',
        excerpt: 'Clinical laboratory teams are conducting multi-center validation around patient-based real-time quality control to accelerate practical adoption.',
        readTime: '3 min',
        category: 'Partnerships'
      }
    }
  },
  {
    id: 'news-20260315',
    date: '2026-03-15',
    bg: 'linear-gradient(135deg,#003d2e,#006d52)',
    icon: 'el-icon-finished',
    featured: false,
    locales: {
      zh: {
        title: 'AI审核规则库升级：覆盖危急值、趋势变化与组合逻辑校验',
        excerpt: '规则库新增更多临床审核场景，支持按项目、科室、仪器和人群灵活配置。',
        readTime: '4 分钟',
        category: '产品更新'
      },
      en: {
        title: 'AI Audit Rule Library Updated for Critical Values and Trend Logic',
        excerpt: 'The rule library adds more clinical audit scenarios and supports flexible configuration by item, department, instrument, and population.',
        readTime: '4 min',
        category: 'Product Updates'
      }
    }
  },
  {
    id: 'news-20260220',
    date: '2026-02-20',
    bg: 'linear-gradient(135deg,#3d2000,#7a4500)',
    icon: 'el-icon-trophy',
    featured: false,
    locales: {
      zh: {
        title: '数字孪生驾驶舱获智慧检验创新应用案例推荐',
        excerpt: '通过一屏呈现质量指标、效率趋势、资源状态和风险事件，辅助检验科进行运营决策。',
        readTime: '2 分钟',
        category: '公司荣誉'
      },
      en: {
        title: 'Digital Twin Command Center Recognized as Smart Lab Innovation Case',
        excerpt: 'A single screen presents quality indicators, efficiency trends, resource status, and risk events to support laboratory operations decisions.',
        readTime: '2 min',
        category: 'Awards'
      }
    }
  },
  {
    id: 'news-20260130',
    date: '2026-01-30',
    bg: 'linear-gradient(135deg,#1a003d,#3d0080)',
    icon: 'el-icon-document',
    featured: false,
    locales: {
      zh: {
        title: '行业白皮书：智慧检验质量管理平台建设路径',
        excerpt: '梳理智慧检验质量管理平台从数据接入、规则引擎到AI辅助审核的建设方法。',
        readTime: '白皮书',
        category: '行业洞察'
      },
      en: {
        title: 'White Paper: Building Smart Laboratory Quality Management Platforms',
        excerpt: 'A practical overview of building smart laboratory quality management platforms from data access and rule engines to AI-assisted audit.',
        readTime: 'White paper',
        category: 'Industry Insights'
      }
    }
  }
]

const emptyLocale = {
  title: '',
  excerpt: '',
  readTime: '',
  category: ''
}

export function normalizeNewsItem(item) {
  const locales = item.locales || {
    zh: {
      title: item.title || '',
      excerpt: item.excerpt || '',
      readTime: item.readTime || '',
      category: item.category || ''
    },
    en: {
      title: item.title || '',
      excerpt: item.excerpt || '',
      readTime: item.readTime || '',
      category: item.category || ''
    }
  }

  return {
    id: item.id || `news-${Date.now()}`,
    date: item.date || new Date().toISOString().slice(0, 10),
    bg: item.bg || 'linear-gradient(135deg,#0a1628,#0d2952)',
    icon: item.icon || 'el-icon-document',
    featured: Boolean(item.featured),
    locales: {
      zh: { ...emptyLocale, ...(locales.zh || {}) },
      en: { ...emptyLocale, ...(locales.en || locales.zh || {}) }
    }
  }
}

export function localizeNewsItem(item, locale = 'zh') {
  const normalized = normalizeNewsItem(item)
  const content = normalized.locales[locale] || normalized.locales.zh

  return {
    ...normalized,
    ...content
  }
}

export function localizeNewsItems(items, locale = 'zh') {
  return items.map(item => localizeNewsItem(item, locale))
}

export function getNewsItems() {
  const saved = window.localStorage.getItem(STORAGE_KEY)
  if (!saved) return defaultNews.map(normalizeNewsItem)

  try {
    const parsed = JSON.parse(saved)
    return Array.isArray(parsed) && parsed.length ? parsed.map(normalizeNewsItem) : defaultNews.map(normalizeNewsItem)
  } catch (e) {
    return defaultNews.map(normalizeNewsItem)
  }
}

export function saveNewsItems(items) {
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items.map(normalizeNewsItem)))
}

export function resetNewsItems() {
  window.localStorage.removeItem(STORAGE_KEY)
}
